import { render, staticRenderFns } from "./list.vue?vue&type=template&id=d1e583f4&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=d1e583f4&prod&lang=scss&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=d1e583f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e583f4",
  null
  
)

export default component.exports